import { type DrawerProps } from './Drawer';

export const DEFAULT_PROPS = {
  size: 'md',
} as const satisfies Omit<DrawerProps, 'children' | 'isOpen'>;

/**
 * CSS custom property written on the drawer header by DrawerHeaderActions with
 * the measured width of the actions slot, and read by the drawer theme to
 * reserve matching space at the end of the header.
 */
export const DRAWER_HEADER_ACTIONS_WIDTH_VAR = '--drawer-header-actions-width';

export const DRAWER_HEADER_ACTIONS_ATTRIBUTE = 'data-drawer-header-actions';

export const OVERLINE_STYLES = {
  color: 'feature.secondary',
  fontSize: 'sm',
  lineHeight: 'sm',
  fontWeight: 'heavy',
  textTransform: 'uppercase',
  mb: 0.5,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
